export const UrlParameter = (parameter) => {
  var reg = new RegExp("(^|&|\\?)"+ parameter +"=([^&#]*)(&|#|$)");
  console.log('reg', reg);
  var r = window.location.href.substr(1).match(reg);
  console.log('urlparameter', reg, r);
  if(r!=null)
    return decodeURIComponent(r[2]);
  return null;
};



// WEBPACK FOOTER //
// ./src/utils/getUrl.js